export default __webpack_public_path__ + "static/media/Gwent-YPMod3-ParticipantGuide.12b0a07f.pdf";